import { render, staticRenderFns } from "./RegistrationCalendarPage.vue?vue&type=template&id=02566a04&scoped=true&"
import script from "./RegistrationCalendarPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationCalendarPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCalendarPage.vue?vue&type=style&index=0&id=02566a04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02566a04",
  null
  
)

export default component.exports